import React from 'react';

type FormFieldProps = {
  label?: React.ReactNode;
  htmlFor?: string;
  children: React.ReactNode;
};

/**
 * grow-ui's `Form.Field`: a full-width block with 1rem above and below and
 * its label in flow above the control. Pair it with a label-less
 * FormikInput or FormikSelect; their own `label` floats instead.
 *
 * `min-w-0` lets it shrink in a flex row: the kit's selects never wrap
 * their value, so without it a long value widens the whole form.
 */
const FormField = ({ label, htmlFor, children }: FormFieldProps) => (
  <div className="relative my-4 w-full min-w-0">
    {label && (
      <label htmlFor={htmlFor} className="text-gray-600 font-medium">
        {label}
      </label>
    )}
    {children}
  </div>
);

export default FormField;
